import { ActionContext } from 'vuex';
import { IDocumentCategories } from '@llws/lift-entity-interfaces';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { DataModifyProcessor } from '@/shared/classes/data-modify-processor';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { subsetObject } from '@/shared';
import config from '@/config';

export default {
  namespaced: true, // 'cities/'
  state: {
    list: undefined,
    single: undefined,
    regions: undefined,
    clientCities: undefined,
  },
  getters: {
  },
  mutations: {

  },
  actions: {
    getCategories: async (ctx: ActionContext<any, any>, siteId: number) => {
      const result = await adminRequest.get(
        `/website-api/sites/${siteId}/document_categories`,
      );
      return result.data;
    },
    getDocumentCategoriesDeleteConflict: async (ctx: IAction<IStateStrict<IDocumentCategories>>, payload: any) => {
      const removingIds:any = [];
      const conflicts: any = [];

      const x = await adminRequest.get(
        `/website-api/sites/${payload.parentId}/documents`,
      );

      payload.data.toRemove.forEach((v: any) => {
        removingIds.push(v.id);
      });

      x.data.forEach(async (c: any) => {
        if (removingIds.includes(c.documentCategoryId)) {
          conflicts.push({ id: c.id, name: c.title });
        }
      });

      return conflicts;
    },
    saveAllCategories: async (ctx: IAction<IStateStrict<IDocumentCategories>>, payload: any) => {
      const processor = new DataModifyProcessor(`${config.adminGateway}/website-api/sites/${payload.parentId}/document_categories`);

      payload.updatedDocuments.forEach(async (c: any) => {
        const temp = c;
        temp.documentCategoryId = null;
        temp.siteId = payload.parentId;
        await adminRequest.put(`/website-api/sites/${payload.parentId}/documents/${c.id}`, temp);
      });

      processor.postItems = payload.data.toInsert.map((v: any) => subsetObject(v, ['page']));
      processor.putItems = payload.data.toUpdate.map((v: any) => subsetObject(v, ['page']));
      processor.deleteItems = payload.data.toRemove;

      await processor.execute();
    },

  },

};
